import axios from "axios";
import qs from "qs";
export interface OpItem {
    id: string;
    oneAnswer?: string;
    moreAnswer?: any;
    isAnswer: boolean;
}

export enum QuestionnaireStatus {
    Idle = "0", //待参与
    Done = "1" //已参与
}

export const QuestionnaireStatusMap = {
    [QuestionnaireStatus.Idle]: "待参与",
    [QuestionnaireStatus.Done]: "已参与"
};

//题目类型
export enum BaseQuestionType {
    SingleChoice = 1,
    MultipleChoice = 2, // 多选
    Subjective = 4 // 主观
}

export interface QuestionnaireListItem {
    id: string;
    title: string;
    exercieStatus: string;
    startTime: string;
    endTime?: string;
    timeRang: string;
    status: string; //0未开始， 1进行中， 2已结束
}

export enum QuestionStatus {
    NotReady,
    Ready,
    End
}

export interface QuestionnaireItem {
    id: number;
    description: string;
    questionnaireStatus: QuestionStatus; //0：未开始，1：进行中，2：已结束
    validityTime: any;
    weekTimeId: number;
    startTime: any;
    endTime: any;
    delStatus: number;
    createUser: number;
    updateUser: number;
    createTime: string;
    updateTime: string;
    questionnaireCount: number;
    questionnaireAllCount: number;
    judgeCount: number;
    noJoinInQuestionnaireCount: number;
    noJudgeCount: number;
    anonymityFlag: BooleanValue;
    studentQuestionnaireStatus: QuestionnaireStatus; //0 未参与， 1 已参与
    joinInQuestionnaireCount: string;
    needJudgeCount: string;
    isHaveQuestion: string;
}

/**
 * 获取问卷活动列表数据
 * @param courseId
 * @param courseNo
 * @param courseSeq
 * @param weekTimeId
 */
export function getQuestionnaireList(
    courseId: string,
    courseNo: string,
    courseSeq: string,
    weekTimeId: number
) {
    return axios
        .post<SuccessData<QuestionnaireItem[]>>(
            `/student/questionnaire/getQuestionnaireList`,
            qs.stringify({
                courseId,
                courseNo,
                courseSeq,
                weekTimeId,
                batchNo: "07"
            })
        )
        .then(data => data.data.data);
}

export interface PaperProps {
    unfinishedCount: string; // 学生未作答试题数
    topics: TopicsItem[];
    topicCount: string; //总题数
    totalScore: string; //总分

    stuDoFlg: string; // 学生试卷是否作答标识(是否提交了，1提交了0未提)
    stuPaperScore: string; // 学生试卷得分
    teacherFinishMark: string; //整张卷批卷状态（0未批，1已批）
    viewPaper: string; //判断活动结束（0未结束，1已结束）
}

export interface TopicsItem {
    index: number;
    contentText: string; //标题
    id: string;
    sort: number;
    stuFinishTopic: string; //是否打完了0未答，1已答
    queTypeId: BaseQuestionType;
    paperId: string;
    stuAns: string;
    typeName: string; //题类型名
    requiredFlag: BooleanValue;
    options: OptionItem[];
    questions: TopicsItem[];

    analysis: string; //（主观题）参考答案
    stuIsRight: string; //是否正确
    stuScore: string; //学生得分
    teacherMark: string; // 教师是否批阅 1:已批阅, 0:未批阅
    teacherComment: string; // 教师评语
    rightAnsText: string; //填空判断选择的正确答案（主观题取参考答案analysis）
    stuAnsText: string; //填空判断的学生答案（主关，填空直接取stuAns）
}

export interface OptionItem {
    isRight: string;
    questionId: string;
    description: string;
    id: string;
    value: string;

    isMatchCase: string; //区分全半角0,1
    isMatchSBCDBC: string; //区分大小写0,1
    isLoseSpace: string; //区分空格0不忽略,1忽略
}

/**
 * 获取试卷
 * @param questionnaireId
 * @param view 传固定值1是查这个试卷答题情况详情
 */
export function getPaper(questionnaireId: string, view?: string) {
    return axios
        .post<SuccessData<PaperProps>>(
            `/student/questionnaire/getPaper`,
            qs.stringify({ questionnaireId, view })
        )
        .then(data => data.data.data)
        .then(data => ({
            unfinishedCount: data.unfinishedCount,
            topicCount: data.topicCount,
            totalScore: data.totalScore,
            topics: data.topics.map((item: TopicsItem, index: number) => ({
                ...item,
                index: index + 1
            })),
            stuDoFlg: data.stuDoFlg,
            stuPaperScore: data.stuPaperScore,
            teacherFinishMark: data.teacherFinishMark,
            viewPaper: data.viewPaper
        }));
}

/**
 * 单题保存
 * @param questionnaireId paperId
 * @param trunkId 小题id
 * @param answer 分题型内容不同, 均为字符串。单选，判断时，值为选项id; 多选值为选项id数组; 填空题值为json格式{"optionId1":"studentAnswer1","optionId2":"studentAnswer2"} ; 主观题值为学员答案
 */
export function saveOne(
    questionnaireId: string,
    trunkId: string,
    answer: string
) {
    return axios
        .post(
            `/student/questionnaire/save`,
            qs.stringify({ questionnaireId, trunkId, answer })
        )
        .then(data => data.data.data);
}

/**
 * 试卷提交
 * @param questionnaireId 试卷id
 * @param paperAnswer 试卷全部答案， 格式为json, key为小题id, value为答案，答案格式跟单题保存格式相同
 * @param courseId 课程id
 */
export function questionSubmit(
    courseId: string,
    questionnaireId: string,
    paperAnswer: string
) {
    return axios
        .post(
            `/student/questionnaire/submit`,
            qs.stringify({ courseId, questionnaireId, paperAnswer })
        )
        .then(data => data.data.data);
}

//找到id下的value返显用
export function findOneValue(id: string, questionnaire: OpItem[]) {
    let answer = "";
    for (let item of questionnaire) {
        if (item.id === id && item.oneAnswer) {
            answer = item.oneAnswer;
            break;
        }
    }
    return answer;
}

export function findMoreValue(id: string, questionnaire: OpItem[]) {
    let answer;
    for (let item of questionnaire) {
        if (item.id === id && item.moreAnswer) {
            answer = item.moreAnswer;
            break;
        }
    }
    return answer;
}

/**
 * 获得未作答试题数
 * @param questionnaireId
 */
export function checkSubmit(questionnaireId: string) {
    return axios
        .post<SuccessData<number>>(
            `/student/questionnaire/checkSubmit`,
            qs.stringify({ questionnaireId })
        )
        .then(data => data.data.data);
}

export interface QuestionnaireProps {
    validityTime: number;
    description: string;
    startTime: string;
    id: string;
    endTime: string;
    courseId: string;
    anonymityFlag: BooleanValue;
    questionnaireStatus: QuestionStatus;
    studentQuestionnaireStatus: QuestionnaireStatus;
}

/**
 * 获取单个问卷
 * @param questionnaireId
 */
export function getQuestionnaire(questionnaireId: string) {
    return axios
        .post<SuccessData<QuestionnaireProps>>(
            `/student/questionnaire/getQuestionnaire`,
            qs.stringify({ questionnaireId })
        )
        .then(data => data.data.data);
}

/**
 * 获取学生试卷状态（查问卷活动详情头部信息）
 * @param questionnaireId
 */
export function getPaperStatus(questionnaireId: string) {
    return axios
        .post<SuccessData<QuestionnaireProps>>(
            `/student/questionnaire/getPaperStatus`,
            qs.stringify({ questionnaireId })
        )
        .then(data => data.data.data);
}
